// extracted by mini-css-extract-plugin
export default {"parentName":"accessCodes_parentName__IFuoi","parentStaff":"accessCodes_parentStaff__7C1+g"};